<template>
	<c-input
		v-if="!readonly || !internalValue"
		:id="id"
		ref="input"
		v-model="internalValue"
		v-bind="$attrs"
		:type="inputType"
		:placeholder="placeholder"
		:readonly="readonly"
		@change="handleChange"
	>
	</c-input>
	<a v-else :href="internalValue" target="_blank" class="is-read-only">{{ internalValue }}</a>
</template>

<script>
	import CInput from './Input.vue';

	export default {
		name: 'CWebsite',
		components: { CInput },
		inheritAttrs: false,
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: { type: String, default: '' },
			inputType: { type: String, default: 'text' },
			id: { type: String, default: null },
			placeholder: { type: String, default: '' },
			readonly: Boolean
		},
		data: function() {
			return {
				internalValue: this.value
			};
		},
		watch: {
			value(newValue) {
				this.internalValue = newValue;
			}
		},
		methods: {
			handleChange() {
				if (this.internalValue && !(this.internalValue.startsWith('https://') || this.internalValue.startsWith('http://')))
					this.internalValue = 'https://' + this.internalValue;
				this.$emit('change', this.internalValue);
			}
		}
	};
</script>